export default __webpack_public_path__ + "static/media/Graphik-Black.fa870e66.otf";